import { render, staticRenderFns } from "./LossFormClaimInfo.vue?vue&type=template&id=57c532c6"
import script from "./LossFormClaimInfo.vue?vue&type=script&lang=ts"
export * from "./LossFormClaimInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports